import './utils/tooltips'
import './utils/toggles'
import './utils/smooth-scroll'
import './utils/load-more'
import './utils/modal'
import './utils/popup'
import './utils/video'
import './menu/menu'
import './menu/menu-btns'
import './utils/gravity-form-inputs'
import '../../inc/acf/lightning-builder/page-components/pc-post-listing/js/filters'
import '../../inc/acf/lightning-builder/page-components/pc-products/js/filters'
import '../../inc/acf/lightning-builder/page-components/pc-post-listing/js/slider'
import '../../inc/acf/lightning-builder/page-components/pc-thumb-slider/js/thumb-slider'
import '../../inc/acf/lightning-builder/page-components/pc-numbers/js/animate-numbers'
import '../../inc/acf/lightning-builder/page-components/pc-events/js/load-more-events'
import '../../inc/acf/lightning-builder/page-components/pc-vertical-slider/js/vertical-slider'
import '../../inc/acf/lightning-builder/page-components/pc-mfn/js/tabs'
import '../../inc/acf/lightning-builder/page-components/pc-product-documents/js/document-filter'
import '../../inc/acf/lightning-builder/page-components/pc-forms/js/forms'

// css
import '../css/app.css'

if (module.hot) {
    module.hot.accept()
}
